import FleetList from "../../pages/FleetManagement"
import FleetEdit from "../../pages/FleetManagement/edit"
import FleetDashboard from "../../pages/FleetManagement/dashboard"
import FleetAllotment from "../../pages/FleetManagement/allotment"
import FleetFuel from "../../pages/FleetManagement/fuel"
import FleetMaintenance from "../../pages/FleetManagement/maintenance"

export const fleetRoutes = [
  { path: "/fleet-dashboard", component: <FleetDashboard /> },
  { path: "/fleet-allotment", component: <FleetAllotment /> },
  { path: "/fleet-fuel", component: <FleetFuel /> },
  { path: "/fleet-maintenance", component: <FleetMaintenance /> },
  { path: "/fleet", component: <FleetList /> },
  { path: "/fleet/add", component: <FleetEdit /> },
  { path: "/fleet/edit/:id", component: <FleetEdit /> },
]
